import React from 'react';
import '../css/Values.css'
import WithAnimation from './WithAnimation'
import AnimationPoint from './AnimationPoint'

import values1 from '../img/values1.png'
import values2 from '../img/values2.png'
import values3 from '../img/values3.png'


class Values extends WithAnimation {
  constructor(props) {
    super(props)

    this.reverse = false
  }

  componentDidMount() {
    this.Timeline.staggerFrom(['#value-1','#value-2','#value-3'], 1.5,{ opacity: 0, rotationX: 90 },.4)
  }

  render(){
    const backGroundStyle1 = { background:`linear-gradient(rgba(117, 175, 152,0.4), rgba(117, 175, 152,0.4)), url(${values1}`, backgroundSize: 'cover' }
    const backGroundStyle2 = { background:`linear-gradient(rgba(117, 175, 152,0.4), rgba(117, 175, 152,0.4)), url(${values2}`, backgroundSize: 'cover' }
    const backGroundStyle3 = { background:`linear-gradient(rgba(117, 175, 152,0.4), rgba(117, 175, 152,0.4)), url(${values3}`, backgroundSize: 'cover' }
    return (
      <div className="container values" style={{margin: '0px'}}>
      <AnimationPoint enter={this.animationEnter} leave={this.animationLeave} bottomOffset={20} />
        <div className="row">
          <div className="col-md-4 value-section" id="value-1" style={backGroundStyle3}><span>Caring Environment</span></div>
          <div className="col-md-4 value-section" id="value-2" style={backGroundStyle2}><span>Walk in philosophy</span></div>
          <div className="col-md-4 value-section" id="value-3" style={backGroundStyle1}><span>Quality Brands</span></div>
        </div>
      </div>
    );
  }
}

export default Values;



// WEBPACK FOOTER //
// ./src/components/Values.jsx